import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  category: belongsTo('category', { inverse: null }),
  productWork: belongsTo('product-work', { inverse: 'workContributors' }),
});
